export const COLUMNS = [
    {
        Header: "Descrição",
        accessor: "descricao",
    }
]


